import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-列表",
  "use": "icon-列表-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-列表\"><defs><style type=\"text/css\"></style></defs><path d=\"M313.26 811.73h646.72v-99.49H313.26v99.49z m0-298.48h646.72v-99.49H313.26v99.49z m0-397.98v99.49h646.72v-99.49H313.26zM64.53 811.73h149.24v-99.49H64.53v99.49z m0-298.48h149.24v-99.49H64.53v99.49z m0-298.49h149.24v-99.49H64.53v99.49z\" p-id=\"1625\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/列表.svg
// module id = Vtmt
// module chunks = 28